module.exports = __webpack_public_path__ + "img/no-data.c36bcf63.png";